export const allGroup = [
    'Land',
    '外景组',
    'Line',
    'Buildings',
    'B3内容',
    'A2内容',
    'A1内容',
    'B1B2内容',
    'PDJ_A',
    'PDJ_D',
    '建筑组',
    'XFBF',
    'SBF',
    '树组',
    '路灯总组',
    // '外场监控'
    // '环境监测点位'
]